import {DG_axios} from "../../../../custom/axios";
import {DG_axiosNormal} from "../../../../custom/axios/normal";
import {BASE_PATH} from "../../../../custom/axios/config/Url";
import {getFormattedDate} from "../../../../components/hrm/timekeeping/time-sheet/timesheet-viewport/items/ExportExcel";

const url = `/dogoo/salary-rest/v2.0/wage-create`
const urlCustom = `/dogoo/salary-rest/v2.0/wage/custom`
const urlTemplate = `/dogoo/salary-rest/v2.0/wage/update-template/`
const baseUrl = `/dogoo/salary-rest/v2.0/wage`
const urlColumns = `/dogoo/salary-rest/v2.0/salary-configs/key-columns`
const urlImport = `/dogoo/salary-rest/v2.0/salary-column/import`
const urlHistory = `/dogoo/salary-rest/v2.0/wage/manual-histories`

export async function getAllSalaryByUser(month, year) {
    const response = await DG_axios.get(`${baseUrl}/view/user`, {
        params: {
            month, year
        }
    })
    return response?.data || []
}


export async function getAllSalary(filter, page, pageSize, search, sort) {
    const response = await DG_axios.get(url, {
        params: {
            filter, page, pageSize, search, sort
        }
    })
    return response?.data || []
}

export async function getAllSalaryCustom(filter, page, pageSize, search, sort) {
    const response = await DG_axios.get(urlCustom, {
        params: {
            filter, page, pageSize, search, sort,
            payrollPeriod : true
        }
    })
    return response?.data || []
}

export async function updateTemplateId(id, templateId) {
    const response = await DG_axiosNormal.put(`${urlTemplate}${id}?templateId=${templateId}`)
    return response?.data || []
}

export async function getDetailHistory(id) {
    const response = await DG_axios.get(`${baseUrl}/manual-add/${id}`, {})
    return response?.data || []
}

export async function getNoteByKey(id, employeeCode, key, index) {

    const params = {
        employeeCode: employeeCode, key: key, index: index

    }

    const response = await DG_axios.get(`${baseUrl}/get-note/${id}`, {params})
    return response?.data || []
}

export async function importFileDetail(id, data) {

    const config = {
        headers: {'Content-Type': 'multipart/form-data'}
    };

    const response = await DG_axiosNormal.post(`${baseUrl}/import/${id}`, data, config)

    return response?.data || []
}

export async function updatePayment(id, data) {

    const response = await DG_axios.post(`${baseUrl}/payment/${id}`, data, null)

    return response?.data || []
}

export async function sendSalaryToUser(id, data) {
    const config = {
        headers: {'Content-Type': 'multipart/form-data'}
    };

    const response = await DG_axiosNormal.post(`${baseUrl}/send-notify-user/${id}`, data, config)

    return response?.data || []
}

export async function importManualAdd(data) {

    const config = {
        headers: {'Content-Type': 'multipart/form-data'}
    };

    const response = await DG_axiosNormal.post(`${baseUrl}/manual-add`, data, config)

    return response?.data || []
}

export async function putImportManualAdd(id, data) {

    const config = {
        headers: {'Content-Type': 'multipart/form-data'}
    };

    const response = await DG_axios.put(`${baseUrl}/manual-add/${id}`, data, config)

    return response?.data || []
}


export async function postSalary(value) {
    const response = await DG_axiosNormal.post(url, value)
    return response?.data || []
}


export async function writeNote(id, value) {
    const response = await DG_axiosNormal.post(`${baseUrl}/add-note/${id}`, value)
    return response?.data || []
}

export async function userRecalculated(id, employeeCode) {


    const response = await DG_axios.get(`${baseUrl}/recalculate/${id}`, {
        params: {
            employeeCode,

        }
    })
    return response?.data || []
}

export async function getSalaryById(id) {
    const response = await DG_axios.get(`${baseUrl}/view` + `/${id}`, null)
    return response?.data || []
}

export async function getConfigImportFieldsSalaryById(id,name) {

    //enCodeFile Name
    const nameEncode = encodeURIComponent(name);

    const response = await DG_axios.get(`${baseUrl}/view/config-import-field` + `/${id}?name=`+nameEncode, null)
    return response?.data || ""
}

export async function getAllUserBySalaryId(id, params) {
    const config = {
        params: params
    };
    const response = await DG_axios.get(`${baseUrl}/show-all-user` + `/${id}`, config)
    return response?.data || []
}

export async function getAllSalaryEnd(id, params) {
    const config = {params: params};
    const response = await DG_axios.get(`${baseUrl}/payment` + `/${id}`, config)
    return response?.data || []
}

export async function getHistoryPayment(id, params) {
    const config = {params: params};
    const response = await DG_axios.get(`${baseUrl}/payment-history` + `/${id}`, config)
    return response?.data || []
}

export async function putIsClose(id, value) {
    const config = {
        headers: {'Content-Type': 'text/plain'}
    };
    const response = await DG_axiosNormal.put(`${baseUrl}/view` + `/${id}`, value, config)
    return response?.data || []
}


export async function deleteSalary(id) {
    const response = await DG_axios.delete(`${baseUrl}/view` + `/${id}`)
    return response?.data || []
}


export async function deleteSalaryByUser(id, employeeCode) {
    const response = await DG_axios.delete(`${baseUrl}/recalculate/${id}`, {
        params: {
            employeeCode,

        }
    })
    return response?.data || []
}

export async function getKeyColumn(index) {
    const response = await DG_axios.get(urlColumns, {
        params: {
            index,
        }
    })
    return response?.data || []
}

export async function getImportConfig(params) {
    const response = await DG_axios.get(urlImport, {
        params: params
    })
    return response?.data || []
}

export async function getExportSalaryTableById(id, params) {

    const config = {
        responseType: 'blob', headers: {
            'Content-Type': 'application/octet-stream',
        }, params: params
    }


    const response = await DG_axios.get(`${baseUrl}/export/${id}`, config)
    return response?.data || []
}
export async function getExportTemplateImportSalaryTableById(id) {

    const config = {
        responseType: 'blob', headers: {
            'Content-Type': 'application/octet-stream',
        }
    }


    const response = await DG_axios.get(`${baseUrl}/template-import/export/${id}`, config)
    return response?.data || []
}

export async function getExportSalaryTableByEmployeeId(id, params) {

    const config = {
        responseType: 'blob', headers: {
            'Content-Type': 'application/octet-stream',
        }, params: params
    }


    const response = await DG_axios.get(`${baseUrl}/manual/export/${id}`, config)
    return response?.data || []
}
export async function getExportTemplateFromSalaryConfig(id,t, params) {

    const config = {
        responseType: 'blob', headers: {
            'Content-Type': 'application/octet-stream',
        }, params: params
    }


    const response = await DG_axios.get(`${baseUrl}/template/export-salary-config/${id}`, config)
    return {
        content :  response?.data ,
        fileName : `${t("tnp.components.salary.fileNameExample")}${getFormattedDate()}.xlsx` ,
    }
}

export async function getExportTemplateSalaryTable(id,t, params) {
    const configFileName = {
        headers: {
            'Content-Type': 'text/plain',
        }, params: params
    }

    // const responseFileName = await DG_axios.get(`${baseUrl}/template/export-file-name/${id}`, configFileName)
    //
    const config = {
        responseType: 'blob', headers: {
            'Content-Type': 'application/octet-stream',
        }, params: params
    }


    const response = await DG_axios.get(`${baseUrl}/template/export/${id}`, config)
    return {
      content :  response?.data ,
      fileName : `${t("tnp.components.salary.fileNameExample")}${getFormattedDate()}.xlsx` ,
      // fileName : responseFileName.data ,
    }
}

export async function getAllSalaryHistoryImport(filter, page, pageSize, search, sort) {
    const response = await DG_axios.get(urlHistory, {
        params: {
            filter, page, pageSize, search, sort
        }
    })
    return response?.data || []
}

export async function updateGradePaymentRoll(id) {

    const response = await DG_axios.get(`${baseUrl}/recalculate-all/${id}`)

    return response?.data || []
}

export async function disconnectSSE(id) {

    const response = await DG_axios.get(`${BASE_PATH}/dogoo/sse/${id}`)

    return response?.data || []
}


export async function checkConnectSSE(id) {

    return  await DG_axios.get(`${BASE_PATH}/dogoo/sse/check-sse/${id}`)

}

export async function processConnectSSE(id) {

    return  await DG_axios.get(`${BASE_PATH}/dogoo/sse/process/${id}`)

}


